export default __webpack_public_path__ + "static/media/desktop-mountain-bg.bcf10726.png";